import React from "react";

const ChevronRight = () => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.40346 12.4067L6.80469 7.20312L1.40346 1.99959" stroke="#0098F0" strokeWidth="1.5" strokeLinecap="square"/>
</svg>
);

export default ChevronRight;
